import { render, staticRenderFns } from "./cabang.vue?vue&type=template&id=5b07b397"
import script from "./cabang.vue?vue&type=script&lang=js"
export * from "./cabang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports